import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './http-services/authservice.service';
import { Complaint, IComplaintCategory, IComplaintCategoryMapping, IExamCategory } from '../interface/dto';
import { lastValueFrom } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { TableParams } from '../components/grid/TableParams';

@Injectable({
  providedIn: 'root'
})
export class ComplaintService {

  constructor(private httpClient: HttpClient, private auth: AuthService) { }

  configureHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
    return headers;
  }

  get selectedComplaintIds() {
    if (this.selectedComplaints == null || this.selectedComplaints.length === 0) {
      return 0;
    }
    return this.selectedComplaints.map(x => x.complaintID);
  }

  setSelectedComplaints(complaints: Complaint[]) {
    sessionStorage.setItem("selectedComplaints", JSON.stringify(complaints));
  }

  get selectedComplaints() {
    return JSON.parse(sessionStorage.getItem("selectedComplaints")) as Complaint[];
  }

  async getAllComplaints(tableParam: TableParams) {
    return lastValueFrom(this.httpClient.patch(`${env.apiURL}complaint/`, tableParam,
      { headers: this.configureHeaders() }), { defaultValue: [] });
  }
  async getComplaintDetails(model: any) {
    return lastValueFrom(this.httpClient.patch(`${env.apiURL}complaint/details`, model,
      { headers: this.configureHeaders() }));
  }
  async saveComplaintReply(model: any) {
    return lastValueFrom(this.httpClient.post(`${env.apiURL}complaint/savereply`, model,
      { headers: this.configureHeaders() }));
  }
  async closeComplaint(complaintId: any) {
    return lastValueFrom(this.httpClient.post(`${env.apiURL}complaint/closecomplaint/${complaintId}`, complaintId,
      { headers: this.configureHeaders() }));
  }
  async deleteComplaintCategory(data: IComplaintCategory) {
    return this.httpClient.delete(`${env.apiURL}complaint/compalintcategory?categoryID=${data.categoryID}`, { headers: this.configureHeaders() }).toPromise();
  }
  async saveComplaintCategory(data: IComplaintCategory) {
    return this.httpClient.post(`${env.apiURL}complaint/compalintcategory`, data, { headers: this.configureHeaders() }).toPromise();
  }
  async getComplaintCategory() {
    return this.httpClient.get(`${env.apiURL}complaint/compalintcategory`, { headers: this.configureHeaders() }).toPromise();
  }

  async deleteComplaintCategoryMap(data: IComplaintCategoryMapping) {
    return this.httpClient.delete(`${env.apiURL}complaint/compalintcategorymap?id=${data.id}`, { headers: this.configureHeaders() }).toPromise();
  }
  async saveComplaintCategoryMap(data: IComplaintCategoryMapping) {
    return this.httpClient.post(`${env.apiURL}complaint/compalintcategorymap`, data, { headers: this.configureHeaders() }).toPromise();
  }
  async getComplaintCategoryMap() {
    return this.httpClient.get(`${env.apiURL}complaint/compalintcategorymap`, { headers: this.configureHeaders() }).toPromise();
  }
}
